<template>
  <slot v-bind="scenarioUnits"></slot>
</template>

<script setup lang="ts">
import type { Scenario } from "@/composables/forms/formTypes";
import { useScenarioUnits } from "./useScenarioUnits";
import { sizingKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";

const props = defineProps<{
  scenario: Scenario | null | undefined;
}>();

const sizing = injectStrict(sizingKey, null);
const scenarioUnits = useScenarioUnits(props.scenario, sizing);
</script>
